module.exports = __webpack_public_path__ + "img/rr-box.1d27eca5.png";